import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "3", y2: "21", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "8 8 4 12 8 16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "16 16 20 12 16 8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SeparatorVertical";
const SeparatorVertical = memo(themed(Icon));
export {
  SeparatorVertical
};
//# sourceMappingURL=separator-vertical.js.map
